import { VerificationStepType } from './types';

export const STEPS_FOR_PRIMARY_APPLICANTS: VerificationStepType[] = [
  'capital-deposit',
  'id',
  'address',
  'shine-start',
  'supporting-docs-beneficiaries',
];
